import { Ship } from "../model/ship";

export class Constants {

  public static readonly SHIPS: Ship[] = [
    { id: 'DE', name: 'Costa Deliziosa' },
    { id: 'DI', name: 'Costa Diadema' },
    { id: 'FA', name: 'Costa Favolosa' },
    { id: 'FO', name: 'Costa Fortuna' },
    { id: 'FS', name: 'Costa Fascinosa' },
    { id: 'PA', name: 'Costa Pacifica' },
    { id: 'SE', name: 'Costa Serena' },
    { id: 'SM', name: 'Costa Smeralda' },
    { id: 'TO', name: 'Costa Toscana' },
  ];

}
